import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MarketingEntry from './MarketingEntry';
import { initDebugLogCapture, recordDebugEvent } from './utils/debugReport';

// ============================================
// INITIALIZE ERROR TRACKING
// ============================================

// Error tracking via console (Sentry removed)
initDebugLogCapture();

// ============================================
// GLOBAL ERROR HANDLERS
// ============================================

/**
 * Handle unhandled promise rejections
 * Prevents silent failures in async operations
 */
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  try {
    recordDebugEvent('unhandledrejection', event?.reason?.message || 'Unhandled promise rejection', {
      stack: event?.reason?.stack,
    });
  } catch (_) {
    // ignore
  }

  // Prevent default browser behavior (console warning)
  event.preventDefault();

  // Log error details for debugging
  console.error('Rejection details:', {
    type: 'unhandledRejection',
    reason: event.reason,
    promise: event.promise,
  });

  // Show user-friendly error message for critical errors
  if (event.reason?.message?.includes('auth') || event.reason?.message?.includes('license')) {
    console.warn('Critical error detected:', event.reason.message);
    // Could show a toast notification here
  }
});

/**
 * Handle uncaught JavaScript errors
 * Provides last line of defense against crashes
 */
window.addEventListener('error', (event) => {
  console.error('Uncaught error:', event.error || event.message);
  try {
    recordDebugEvent('error', event?.message || 'Uncaught error', {
      filename: event?.filename,
      lineno: event?.lineno,
      colno: event?.colno,
      stack: event?.error?.stack,
    });
  } catch (_) {
    // ignore
  }

  // Prevent React from unmounting (keep app running)
  event.preventDefault();

  // Log error details for debugging
  if (event.error) {
    console.error('Error details:', {
      type: 'uncaughtError',
      error: event.error,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    });
  }
});

/**
 * Safe JSON.parse wrapper
 * Prevents crashes from corrupted localStorage data
 */
window.safeJSONParse = (jsonString, fallback = null) => {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('JSON parse error:', error);
    return fallback;
  }
};

// ============================================
// RENDER APPLICATION
// ============================================

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MarketingEntry />
  </React.StrictMode>
);
